import { useQueryState } from 'nuqs';

const useSelectedCaseQs = () => {
  const [selectedCase, setSelectedCase] = useQueryState<string>('case', {
    defaultValue: '',
    history: 'push',
    parse: (value) => value,
    serialize: (value) => value,
  });

  return {
    selectedCase,
    handleSelectedCase: setSelectedCase,
  };
};

export default useSelectedCaseQs;
